export const ACTION_NAV_DASHBOARD = 'ACTION_NAV_DASHBOARD';
export const ACTION_NAV_VIEW_FOLDER = 'ACTION_NAV_VIEW_FOLDER';
export const ACTION_NAV_VIEW_FILE = 'ACTION_NAV_VIEW_FILE';
export const ACTION_NAV_CREATE_FILE = 'ACTION_NAV_CREATE_FILE';
export const ACTION_NAV_EDIT_FILE = 'ACTION_NAV_EDIT_FILE';
export const ACTION_NAV_CREATE_FILE_ENTRY = 'ACTION_NAV_CREATE_FILE_ENTRY';
export const ACTION_NAV_VIEW_FILE_ENTRY = 'ACTION_NAV_VIEW_FILE_ENTRY';
export const ACTION_NAV_SEARCH = 'ACTION_NAV_SEARCH';
export const ACTION_NAV_USERS = 'ACTION_NAV_USERS';